/**
 * Gates the in-module Commissions Configuration to commission admins; a plain
 * BD who types the URL is bounced back to their statement.
 */
import { Navigate } from 'react-router-dom';
import { useIsCommissionsAdmin } from './useIsCommissionsAdmin';

export function RequireCommissionsAdmin({ children }: { children: React.ReactNode }) {
  const isAdmin = useIsCommissionsAdmin();
  if (!isAdmin) return <Navigate to="/commissions" replace />;
  return <>{children}</>;
}
